import api from './api';
import types from './mutation-types';
import moment from 'moment';

//날짜 포맷 변경 함수
const dateFormat = ts => {
	if (!ts) return ts;
	return moment(ts).format('YYYY-MM-DD HH:mm:ss');
};

export default {
	//State 변경 Action
	setState_({ commit }, { key, value }) {
		commit(types.SET_STATE, { key, value });
	},

	//공통 코드 조회: 사용 유무
	getUseYnList_({ commit, rootState, rootGetters }) {
		return api
			.getUseYnList({ plantCd: rootState.commonStore.user.plantCd, commCdType: 'USE_YN' }) //USE_YN 공통 API 조회
			.then(res => {
				if (res.header.code === 0) {
					//API 응답이 정상일 경우
					// const getMessage_ = rootGetters['commonStore/getMessage_']; //전역 Store의 다국어 처리 getter 호출
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					commit(types.SET_STATE, { key: 'useYnOptions', value }); //Select Box Options 값 Vuex에 저장
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//조회 Action
	select_({ commit }, { currentPage, pageUnit, ...params }) {
		return api
			.select({ params, currentPage, pageUnit })
			.then(res => {
				if (res.header.code === 0) {
					const {
						result,
						pagingInfo: { currentPage, pageUnit, totalSize }
					} = res.body;

					//날짜 포맷 변경
					const data = result.map(row => ({
						...row,
						dRegDt: dateFormat(row.regDt),
						dChgDt: dateFormat(row.chgDt)
					}));

					//테이블 페이징 조회를 위한 검색조건 저장
					commit(types.SET_STATE, { key: 'searchParams', value: params });
					//조회 데이터 저장
					commit(types.SET_STATE, { key: 'notifications', value: { currentPage, pageUnit, totalSize, data } });
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//등록 Action
	register_({ dispatch, state, rootState }, { notiTitle, notiContent }) {
		return api
			.register({ notiTitle, notiContent, plantCd: rootState.commonStore.user.plantCd })
			.then(res => {
				if (res.header.code === 0) {
					//등록 성공시 공지사항 재조회
					dispatch('select_', {
						currentPage: state.notifications.currentPage,
						pageUnit: state.notifications.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//수정 Action
	modify_({ dispatch, state }, { notiTitle, notiContent, useYn, notiSeq }) {
		return api
			.modify({ notiTitle, notiContent, useYn, notiSeq })
			.then(res => {
				if (res.header.code === 0) {
					//수정 성공시 공지사항 재조회
					dispatch('select_', {
						currentPage: state.notifications.currentPage,
						pageUnit: state.notifications.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	//삭제 Action
	delete_({ dispatch, state }, targetRows) {
		const seqList = targetRows.map(r => r.notiSeq);

		return api
			.delete({ seqList })
			.then(res => {
				if (res.header.code === 0) {
					// 삭제 성공시 공지사항 재조회
					dispatch('select_', {
						currentPage: state.notifications.currentPage,
						pageUnit: state.notifications.pageUnit,
						...state.searchParams
					});
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	}
};
